import { FlexRow, LabeledInput } from '@gorila-shared-ui/components';
import { useEffect } from 'react';
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { PATHS_REPORT_DISTANCE_OPTIONS, PATHS_REPORT_TIME_OPTIONS } from '../../../constants/reports';
import { pathDistanceFilterState, pathTimeFilterState, reportIsManualIntervalState } from '../../../storage/reports';
import { preventDotAndComma, preventMinus } from '../../../utils/formUtilis';
import { EnhancedLabeledSelect } from '../../ui/EnhancedLabeledSelect';

function PathsReportFilters() {
  const [time, setTime] = useRecoilState(pathTimeFilterState);
  const resetTime = useResetRecoilState(pathTimeFilterState);
  const [distance, setDistance] = useRecoilState(pathDistanceFilterState);
  const resetDistance = useResetRecoilState(pathDistanceFilterState);
  const isManualInterval = useRecoilValue(reportIsManualIntervalState);

  useEffect(() => {
    if (!isManualInterval) {
      resetTime();
      resetDistance();
    }
  }, [isManualInterval]);

  if (isManualInterval) {
    return (
      <FlexRow>
        <LabeledInput
          label="Tiempo mínimo:"
          onChange={(value) => {
            setTime(+value);
          }}
          value={time.toString()}
          endEnhancer="minutos"
          onKeyDown={(event) => {
            preventDotAndComma(event);
            preventMinus(event);
          }}
          type="number"
          min={0}
        />
        <LabeledInput
          label="Distancia mínima:"
          onChange={(value) => {
            setDistance(+value);
          }}
          value={distance.toString()}
          endEnhancer="metros"
          onKeyDown={(event) => {
            preventDotAndComma(event);
            preventMinus(event);
          }}
          type="number"
          min={0}
        />
      </FlexRow>
    );
  }

  return (
    <FlexRow>
      <EnhancedLabeledSelect
        label="Tiempo mínimo:"
        onChange={(params) => {
          setTime((params.option?.id as number) || 2);
        }}
        value={[{ id: time }]}
        options={PATHS_REPORT_TIME_OPTIONS}
        inline
        inset
      />
      <EnhancedLabeledSelect
        label="Distancia mínima:"
        onChange={(params) => {
          setDistance((params.option?.id as number) || 700);
        }}
        value={[{ id: distance }]}
        options={PATHS_REPORT_DISTANCE_OPTIONS}
        inline
        inset
      />
    </FlexRow>
  );
}

export default PathsReportFilters;
